import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "pk_cart_v1";

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch { /* ignore */ }
    }, [items]);

    const addItem = (product, { size = null, quantity = 1 } = {}) => {
        setItems((prev) => {
            const key = (i) => `${i.product_id}::${i.size || ""}`;
            const incoming = {
                product_id: product.id,
                product_name: product.name,
                image_url: product.image_url,
                size,
                quantity,
                unit_price_cents: product.price_cents,
            };
            const idx = prev.findIndex((p) => key(p) === key(incoming));
            if (idx >= 0) {
                const copy = [...prev];
                copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + quantity };
                return copy;
            }
            return [...prev, incoming];
        });
    };

    const updateQty = (product_id, size, quantity) => {
        setItems((prev) => prev.map((i) =>
            i.product_id === product_id && (i.size || "") === (size || "")
                ? { ...i, quantity: Math.max(1, quantity) }
                : i,
        ));
    };

    const removeItem = (product_id, size) => {
        setItems((prev) => prev.filter((i) =>
            !(i.product_id === product_id && (i.size || "") === (size || "")),
        ));
    };

    const clear = () => setItems([]);

    const subtotalCents = items.reduce((s, i) => s + i.unit_price_cents * i.quantity, 0);
    const count = items.reduce((s, i) => s + i.quantity, 0);

    return (
        <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, subtotalCents, count }}>
            {children}
        </CartContext.Provider>
    );
}

export function useCart() {
    return useContext(CartContext);
}
